
(function(){
  document.addEventListener('click',function(e){
    var t=e.target; var b=(t&&t.closest)?t.closest('#pf-save'):null;
    if(b){ var n=document.getElementById('pf-name'); var g=document.getElementById('pf-grade'); var sc=document.getElementById('pf-school');
      var miss=null, foc=null;
      if(n && !n.value.trim()){ miss='이름(또는 별명)'; foc=n; }
      else if(g && !g.value){ miss='학년'; foc=g; }
      else if(sc && !sc.value.trim()){ miss='학교/기관'; foc=sc; }
      if(miss){ e.preventDefault(); e.stopImmediatePropagation();
        try{alert(miss+'을(를) 입력해 주세요. 이름·학년·학교를 모두 입력해야 검사를 시작할 수 있습니다.');}catch(_){}
        try{ if(foc) foc.focus(); }catch(_){}
      }
    }
  },true);
})();
